import combinedGACall from '../combinedGACall';

export default (action) =>
	combinedGACall({
		category: 'VaccTrak hub',
		action,
	});
